import { TableColumnType } from 'src/types/table';

export const CLAIM_IMPORT_PREVIEW_COLUMNS: TableColumnType[] = [
    { label: 'fcn', key: 'FCN', defaultShow: true },
    {
        label: 'status',
        key: 'STATUS',
        defaultShow: true,
        type: 'select',
        selectOption: 'claimStatusCodes',
    },
    { label: 'transportPrice', key: 'TRANSPORT_PRICE', defaultShow: true },
    { label: 'goodsPrice', key: 'GOODS_PRICE', defaultShow: true },
    { label: 'totalServicePrice', key: 'TOTAL_SERVICE_PRICE', defaultShow: true },
    {
        label: 'compensationCurrency',
        key: 'COMPENSATION_CURRENCY',
        defaultShow: true,
        type: 'select',
        selectOption: 'currencyCodes',
    },
    { label: 'carrierInvoiceReference', key: 'CARRIER_INVOICE_REFERENCE', defaultShow: true },
    { label: 'issuesMonthOrigin', key: 'ISSUES_MONTH_ORIGIN', defaultShow: true, type: 'date' },
];
